// TOKEN TO TRADE
export const TRADING_TOKEN = "XUSDC";
export const TRADING_TOKEN_CONTRACT = process.env.REACT_APP_TOKEN_CONTRACT || "xtokens";
export const PLATFORM_TOKEN_PRECISION = 6;

// MARKET CREATION
export const MAX_MULTI_OUTCOMES = 5;
export const max_description_characters = 512;
export const max_resolution_characters = 512;

// APP NAME
export const APP_NAME = process.env.REACT_APP_NAME || "XPR Prediction Market";
